module.exports = __webpack_public_path__ + "img/sol_cap2.773c4f57.png";